export default __webpack_public_path__ + "static/media/graph.c6183e49.png";